/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import { injectIntl } from 'react-intl';
import {
  Col,
  Grid,
  Nav,
  NavItem,
  Row,
  Tab,
} from 'react-bootstrap';
import IntlMsg from 'lorautils/intl/IntlMsg';
import Toolbar from 'loracoms/Toolbar';
import PageLoading from 'loracoms/PageLoading';
import PageNoPerm from 'loracoms/PageNoPerm';
import Nvl from 'loracoms/Nvl';
import config from 'loracfg';
import { normalizeDevEUI } from 'lorautils/IdUtils';
import SendData from './coms/SendData';
import ResetSeq from './coms/ResetSeq';
import ParsedData from './coms/ParsedData';
import styles from './styles.scss';
import DeviceData from '../DeviceData';

const propTypes = {
  intl: React.PropTypes.any.isRequired,
  pushState: React.PropTypes.func.isRequired,
  appId: React.PropTypes.string.isRequired,
  deviceId: React.PropTypes.string.isRequired,
  deviceState: React.PropTypes.object.isRequired,
  appState: React.PropTypes.object.isRequired,
  plan: React.PropTypes.object.isRequired,
  replaceState: React.PropTypes.func.isRequired,
};

class DataToolView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      deviceState: props.deviceState,
      appState: props.appState,
      plan: props.plan,
      view: 'datanews',
    };
    this.intlMsg = new IntlMsg(props.intl, 'devicedetail.datatoolview');
  }

  componentWillReceiveProps(nextProps) {
    const { deviceState, plan, appState } = nextProps;
    if (deviceState !== this.props.deviceState) {
      this.setState({ deviceState });
    }
    if (appState !== this.props.appState) {
      this.setState({ appState });
    }
    if (plan !== this.props.plan) {
      this.setState({ plan });
    }
  }

  handleSelect(view) {
    this.setState({ view });
  }

  renderToolbar() {
    const { pushState, appId, deviceId, replaceState } = this.props;
    const {
      deviceState: {
        data: device = {},
        status,
      },
      appState: {
        data: { name: appName } = {},
        status: appStatus,
      },
    } = this.state;
    const breadcrumb = [{
      content: this.intlMsg.msg('breadcrumb.application', 'application'),
      onClick: () => pushState('/application'),
    }, {
      content: <Nvl val={appName} status={appStatus} />,
      onClick: () => replaceState(`/application/${appId}`),
    }, {
      content: <Nvl val={device.name || normalizeDevEUI(deviceId)} status={status} />,
      active: true,
    }];
    return <Toolbar breadcrumb={breadcrumb} />;
  }

  renderTools() {
    const { deviceId } = this.props;
    return (
      <div className={styles.tools}>
        <Tab.Container id="datatools" defaultActiveKey="senddata">
          <Row className="clearfix">
            <Col md={12}>
              <Nav bsStyle="aisz-tabs">
                <NavItem eventKey="senddata">
                  {this.intlMsg.msg('tab.senddata')}
                </NavItem>
                <NavItem eventKey="resetseq">
                  {this.intlMsg.msg('tab.lorawanseq')}
                </NavItem>
              </Nav>
              <Tab.Content animation className="aisz-tab-content-white">
                <Tab.Pane eventKey="senddata">
                  <div className={styles.toolWrapper}>
                    <SendData deviceId={deviceId} />
                  </div>
                </Tab.Pane>
                <Tab.Pane eventKey="resetseq">
                  <div className={styles.toolWrapper}>
                    <ResetSeq deviceId={deviceId} />
                  </div>
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </Row>
        </Tab.Container>
      </div>
    );
  }

  renderData() {
    const { view } = this.state;
    const { deviceId, appId } = this.props;

    return (
      <div className={styles.tools}>
        <Tab.Container id="news_container" defaultActiveKey="datanews">
          <Row className="clearfix">
            <Col md={12}>
              <Nav bsStyle="aisz-tabs">
                <NavItem eventKey="datanews" onSelect={e => this.handleSelect(e)}>
                  {this.intlMsg.msg('data.header', 'devicedetail')}
                </NavItem>
                {
                config.profile === 'cloud' &&
                  <NavItem eventKey="parsenews" onSelect={e => this.handleSelect(e)}>
                    {this.intlMsg.msg('parsed.header', 'devicedetail')}
                  </NavItem>
                }
              </Nav>
              <Tab.Content animation className="aisz-tab-content-white">
                <Tab.Pane eventKey="datanews">
                  <DeviceData deviceId={deviceId} />
                </Tab.Pane>
                {
                  config.profile === 'cloud' &&
                  <Tab.Pane eventKey="parsenews">
                    <ParsedData deveui={deviceId} appId={appId} load={view === 'parsenews'} />
                  </Tab.Pane>
                }
              </Tab.Content>
            </Col>
          </Row>
        </Tab.Container>
      </div>
    );
  }

  render() {
    const { plan } = this.state;
    if (plan.status !== 'success') {
      return <PageLoading />;
    }

    if (plan.data.tier === 1) {
      return <PageNoPerm />;
    }

    return (
      <Grid fluid>
        <Row>
          <Col md={12}>
            {this.renderToolbar()}
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            {this.renderTools()}
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            {this.renderData()}
          </Col>
        </Row>
      </Grid>
    );
  }
}

DataToolView.propTypes = propTypes;

const mapStateToProps = (state, ownProps) => ({
  deviceState: state.device.getDevice,
  appState: state.app.getApp,
  plan: state.billing.plan,
  deviceId: ownProps.params.deviceId,
  appId: ownProps.params.appId,
});

const mapDispatchToProps = {
  pushState: routerActions.push,
  replaceState: routerActions.replace,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(DataToolView));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/DeviceDetail/coms/DataToolView/index.jsx